import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { get, del } from 'api/fetch';

export const fetchClaims = createAsyncThunk(
  'nomad_insurance/claims',
  async (_, { rejectWithValue }) => {
    try {
      const claims = await get('/claims/v3', {
        isNIOrchestrator: true
      });
      return claims;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteClaim = createAsyncThunk(
  'nomad_insurance/claim/deleteClaim',
  async ({ claimID }, { rejectWithValue }) => {
    try {
      await del(`/claims/v1/${claimID}`, undefined, {
        isNIOrchestrator: true
      });
      return claimID;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const slice = createSlice({
  name: 'nomad_insurance/claims',
  initialState: {
    isLoading: false,
    error: null,
    claims: null,
    deleteClaimError: null
  },
  reducers: {},
  extraReducers: {
    [fetchClaims.pending]: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    [fetchClaims.fulfilled]: (state, { payload }) => {
      state.claims = payload;
      state.isLoading = false;
      state.error = null;
    },
    [fetchClaims.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    },
    [deleteClaim.pending]: (state) => {
      state.isLoading = true;
      state.deleteClaimError = null;
    },
    [deleteClaim.fulfilled]: (state, { payload: claimId }) => {
      state.isLoading = false;
      state.claims = state.claims.filter((claim) => claim.id !== claimId);
      state.deleteClaimError = null;
    },
    [deleteClaim.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.deleteClaimError = payload;
    }
  }
});

export const { ...actions } = slice.actions;
export default slice.reducer;
